import NoAssistanceResults from './NoAssistanceResults';

export default NoAssistanceResults;
